/**
 * @file PickingRebuildButton.tsx
 * @description Кнопка «Пересобрать задание» с подтверждением (phase19.23).
 *
 * Нужна прямо в полосе «Строки задания потерялись»: раньше подсказка
 * отправляла кладовщика искать пункт в меню ⋯, а в статусе «в работе» его там
 * не было — тупик (замечание пользователя 2026-09-16). Действие и текст
 * подтверждения те же, что у пункта меню (`PICKING_CONFIRM_TEXT`).
 *
 * Право проверяет вызывающий: кнопку показываем только под `SHOP_WMS_MANAGE`.
 */

import { RefreshCw } from "lucide-react";
import { useState } from "react";

import { PickingConfirmDialog } from "./PickingConfirmDialog";
import { Button } from "../../ui/button";

interface Props {
  onRebuild: () => void;
  busy: boolean;
}

export function PickingRebuildButton({ onRebuild, busy }: Props) {
  const [confirm, setConfirm] = useState(false);
  return (
    <>
      <Button
        variant="outline"
        className="min-h-12 self-start"
        disabled={busy}
        onClick={() => setConfirm(true)}
      >
        <RefreshCw className="size-4" />
        <span className="ml-1.5">Пересобрать задание</span>
      </Button>
      <PickingConfirmDialog
        kind={confirm ? "rebuild" : null}
        busy={busy}
        onCancel={() => setConfirm(false)}
        onConfirm={() => {
          setConfirm(false);
          onRebuild();
        }}
      />
    </>
  );
}
